<template>
    <v-card>
        <v-toolbar color="blue-grey" dark flat>
            <v-toolbar-title>Lista task e sottotask</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="success" rounded @click="addTask()" v-if="!disabled"><v-icon left>add</v-icon>Aggiungi
                fase</v-btn>
        </v-toolbar>
        <v-data-table :headers="headers" :disable-pagination="true" hide-default-footer :items="taskList"
            item-key="_subTaskKey" group-by="_taskKey" ref="taskTable">
            <template v-slot:group="{ group, items }">
                <taskgroup-header v-bind="{ group, items, disabled, permissions }" @edit="editTask" @addSubtask="addSubtask" @duplicateTask="duplicateTask"
                    :key="group"></taskgroup-header>
                <tr v-for="item of items" :key="item._subtaskKey">
                    <template v-if="item.subTask">
                        <td><strong>{{ item.task_name }}</strong> <v-icon>chevron_right</v-icon> {{ item.subTask.name }}
                        </td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.date_start | date }}</td>
                        <td>{{ item.date_end | date }}</td>
                        <td>
                            <sal-progressbar :small="true" :value="item.progress"></sal-progressbar>
                        </td>
                        <td>
                            <nice-time-editor v-if="permissions.includes('view_sub_tasks_resources_hours')" :disabled="true" :value="item.hours"></nice-time-editor>
                            <span v-else>-</span>
                        </td>
                        <td>
                            <nice-time-editor v-if="permissions.includes('view_sub_tasks_resources_hours_real')" :disabled="true" :value="item.hours_real"></nice-time-editor>
                            <span v-else>-</span>
                        </td>
                        <td>
                            <template v-if="item.active"><v-icon color="success">check_circle</v-icon></template>
                            <template v-else><v-icon color="error">cancel</v-icon></template>
                        </td>
                        <td>
                            <template v-if="item.info">
                                <price-info v-if="permissions.includes('view_sub_tasks_resources_price')" :value="item.info"></price-info>
                                <span v-else>-</span>
                            </template>
                        </td>
                        <td class="text-right">
                            <v-btn small icon color="purple"
                                @click="showSubtaskEvent(item.subTask)"><v-icon>event</v-icon></v-btn>
                            <v-btn small icon color="warning" @click="editSubtask(item.subTask, item.task)"><v-icon>{{
                                disabled ? 'more_vert' : 'edit' }}</v-icon></v-btn>
                        </td>
                    </template>
                    <template v-else>
                        <td :colspan="headers.length">
                            <v-alert outlined type="warning" dense class="ma-2">
                                Nessun task presente
                                <v-btn v-if="!disabled" small color="success" class="ml-2"
                                    @click="addSubtask(item.task)"><v-icon left>add</v-icon>Aggiungi</v-btn>
                            </v-alert>
                        </td>
                    </template>
                </tr>

            </template>
        </v-data-table>
        <!-- edit fase popup -->
        <v-dialog :value="!!edit_task" persistent scrollable max-width="800">
            <task-editor v-model="edit_task" @close="edit_task = null" @save="saveTask" @delete="deleteTask"
                v-bind="{ loading, disabled }" />
        </v-dialog>
        <!-- edit sottofase popup -->
        <v-dialog :value="!!edit_subtask" persistent scrollable max-width="1200">
            <subtask-editor v-model="edit_subtask" @close="edit_subtask = null" @save="saveSubtask"
                v-bind="{ loading, disabled, showPrices, permissions, user }" @delete="deleteSubtask" />
        </v-dialog>
    </v-card>
</template>
<script>
import { calculateTaskInfo, calculateSubTaskInfo, getUUID } from './ProjectUtils.js'

import TaskgroupHeader from './TaskgroupHeader.vue';
import TaskEditor from './TaskEditor.vue';
import SubtaskEditor from './SubtaskEditor.vue';

export default {
    props: {
        value: { required: true, type: Object },
        disabled: { default: false },
        loading: { default: false },
        showPrices: { type: Boolean, default: true },
        permissions: {type: Array, default: []},
        user:{type:Object, required: true},
    },
    data() {
        return {
            edit_task: null,
            edit_task_index: null,
            edit_subtask: null,
            edit_subtask_index: null,
        }
    },
    mounted() {
    },
    computed: {
        headers() {
            return [
                { text: 'Nome', value: 'name' },
                { text: 'Descrizione', value: 'description' },
                { text: 'Inizio', value: 'date_start' },
                { text: 'Fine', value: 'date_end' },
                { text: 'SAL', value: 'progress', width: 100 },
                { text: 'Ore', value: 'hours', width: 100 },
                { text: 'Ore reali', value: 'hours_real', width: 100 },
                { text: 'Attiva', value: 'active' },
                { text: 'Importo', value: 'info.priceDiff' },
                { text: '', value: 'actions', sortable: false }

            ];
        },
        taskList() {
            let tasks = [];
            for (let taskIndex in this.value.tasks) {
                const task = this.value.tasks[taskIndex];

                const taskInfo = calculateTaskInfo(task);
                const _taskKey = getUUID('task-');

                if (task.sub_tasks.length > 0) {
                    for (let subTask of task.sub_tasks) {
                        const _subtaskKey = getUUID('subtask-');

                        const info = calculateSubTaskInfo(subTask);

                        

                        tasks.push({
                            taskIndex,
                            task,
                            task_name: task.name,
                            task_description: task.description,

                            name: task.name + ' / ' + subTask.name,

                            description: subTask.description,
                            date_start: subTask.date_start,
                            date_end: subTask.date_end,
                            progress: subTask.progress,
                            active: subTask.active,

                            hours: this.permissions.includes("view_sub_tasks_resources_hours") ? info.hours : "-",
                            hours_real: this.permissions.includes("view_sub_tasks_resources_hours_real") ? info.hours_real : "-",

                            info,
                            subTask,
                            taskInfo,

                            _taskKey,
                            _subtaskKey,
                        });
                    }
                } else {
                    const _subtaskKey = getUUID('null_subtask-');
                    tasks.push({
                        taskIndex,
                        task,
                        task_name: task.name,
                        task_description: task.description,

                        name: task.name,
                        description: null,
                        date_start: null,
                        date_end: null,
                        progress: taskInfo.progress,///calculated
                        active: null,

                        hours: this.permissions.includes("view_sub_tasks_resources_hours") ? taskInfo.hours : "-",
                        hours_real: this.permissions.includes("view_sub_tasks_resources_hours_real") ? taskInfo.hours_real : "-",

                        info: null,
                        subTask: null,
                        taskInfo,

                        _taskKey,
                        _subtaskKey,
                    });
                }
            }

            return tasks;
        }
    },
    methods: {
        duplicateTask(task) {
            if (confirm(trans('projects.duplicate_task_confirm'))) {
                // clone "grezzo" del task
                let newTask = JSON.parse(JSON.stringify(task));

                // modifico il nome e resetto l'id del task duplicato
                newTask.name += ' (copia)';
                newTask.id = null;

                // duplico le sub_tasks
                newTask.sub_tasks = task.sub_tasks.map(st => {
                    return {
                        id: null,
                        name: st.name,
                        description: st.description,
                        date_start: st.date_start,
                        date_end: st.date_end,
                        active: st.active,
                        progress: 0,
                        resources: [],
                        sals: []
                    };
                });

                // aggiungo il task duplicato alla lista
                this.value.tasks.push(newTask);
            }
        },
        _subtaskIndex(subtask, task) {
            const index = task.sub_tasks.indexOf(subtask);
            return index >= 0 ? index : null;
        },
        _taskIndex(task) {
            const index = this.value.tasks.indexOf(task);
            return index >= 0 ? index : null;
        },
        addSubtask(task) {
            this.editSubtask({}, task);
        },
        addTask() {
            this.edit_task_index = null;
            this.edit_subtask_index = null;
            this.edit_task = {};
        },
        editTask(task) {
            this.edit_task = task;
            this.edit_task_index = this._taskIndex(task);
        },
        editSubtask(subTask, originalTask) {
            console.warn('edit subtask', { subTask, originalTask });

            this.edit_task_index = this._taskIndex(originalTask);
            this.edit_subtask_index = this._subtaskIndex(subTask, originalTask);
            this.edit_subtask = subTask;
        },
        saveTask(newTask) {
            if (this.edit_task_index === null) {
                this.value.tasks.push(newTask);
            } else {
                Object.assign(this.value.tasks[this.edit_task_index], newTask);
            }

            this.closeEditTask();
        },
        deleteTask(task) {
            this.value.tasks.splice(this.edit_task_index, 1);
            this.closeEditTask();
        },
        closeEditTask() {
            this.edit_task = null;
            this.edit_subtask = null;
            this.edit_task_index = null;
            this.edit_subtask_index = null;
        },
        saveSubtask(newSubtask) {
            let originalTask = this.value.tasks[this.edit_task_index];

            if (!originalTask) {
                alert('ERROR: task originario non trovato!');
                return;
            }

            if (this.edit_subtask_index === null) {
                originalTask.sub_tasks.push(newSubtask);
            } else {
                Object.assign(originalTask.sub_tasks[this.edit_subtask_index], newSubtask);
            }

            this.closeSubtaskEditor();
        },
        closeSubtaskEditor() {

            this.edit_task = null;
            this.edit_subtask = null;
            this.edit_task_index = null;
            this.edit_subtask_index = null;
        },
        showSubtaskEvent(subTask) {
            this.$emit('show-subtask-event', subTask);
        },
        deleteSubtask(e) {
            console.warn('deleteSubtask', e);

            let originalTask = this.value.tasks[this.edit_task_index];

            if (!originalTask) {
                alert('ERROR: task originario non trovato!');
                return;
            }
            originalTask.sub_tasks.splice(this.edit_subtask_index, 1);

            this.closeSubtaskEditor();
        },
    },
    watch: {
        'value.tasks': {
            deep: true,
            handler() {
                console.warn('tasks updated!!!')
                //this.$refs.taskTable.$forceUpdate()
            }
        }
    },
    components: {
        TaskgroupHeader,
        TaskEditor,
        SubtaskEditor,
    },
    filters: {}

}
</script>